import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils/cn';

export function Logo({ className }: { className?: string }) {
  return (
    <Link
      to="/"
      className={cn('inline-flex items-center gap-2 focus-visible:outline-none', className)}
      aria-label="Care For Him — home"
    >
      <img src="/logo.jpeg" alt="Care For Him" className="h-11 w-auto" width={110} height={44} />
    </Link>
  );
}
